<template>
    <div class="view-qualify-step-building-and-shelving qualify-sidebar">
        <section v-for="(group, index) in fieldGroups" :key="`${currentStep}_group_${index}`">
            <h2 class="sidebar-title">
              {{ group.label }}
            </h2>
            <template v-for="(field, index) in group.questions">
              <qualify-sidebar-input-container :label="field.label" :key="`${currentStep}_field_${index}`">
                <template v-if="field.type === 'ramp'">
                  <qualify-sidebar-input-item :suffix="$tc('x_of_length', field.unit[unitType])" :is-filled="fields['rampLength'] !== ''">
                    <b-input
                        v-model="fields.rampLength"
                        size="is-large"
                        class="small-input"
                        @focus="setRevealPosition('rampLength', 0.10, 42, 82)"
                        @blur="setRevealPosition('rampLength')"
                        rounded
                    />
                  </qualify-sidebar-input-item>
                  <qualify-sidebar-input-item :suffix="$tc('x_of_height', field.unit[unitType])" :is-filled="fields['rampHeight'] !== ''">
                    <b-input
                        v-model="fields.rampHeight"
                        size="is-large"
                        class="small-input"
                        @focus="setRevealPosition('rampHeight', 0.04, 44, 77)"
                        @blur="setRevealPosition('rampHeight')"
                        rounded
                    />
                  </qualify-sidebar-input-item>

                  <transition-group name="fade">
                    <qualify-sidebar-input-item key="field_ramp_diagonal" :suffix="'mm de diagonale'">
                      <b-input
                          v-model="rampDiagonal"
                          size="is-large"
                          class="small-input"
                          @focus="setRevealPosition('rampDiagonal', 0.08, 42, 82)"
                          @blur="setRevealPosition('rampDiagonal')"
                          rounded
                      />
                    </qualify-sidebar-input-item>

                    <p key="ramp_calc_error_message" class="ramp-slope-percentage-calc" :class="brandBackgroundColor" v-if="rampError && !fields.rampHeight">{{ rampError }}</p>

                    <div class="ramp-slope-percentage-calc" :key="`result_ramp`" :class="brandBackgroundColor" v-if="rampDiagonal && rampPercentage">
                      = {{ $tc('slope_of', rampPercentage)}}
                    </div>
                  </transition-group>
                </template>
                <qualify-sidebar-input-item :is-filled="fields[field.slug] !== ''" v-else-if="(field.type === 'checkbox' && field.answers === 1) || field.slug === 'energy_diesel'">
                  <b-checkbox
                      v-model="fields[field.slug]"
                      type="checkbox"
                      class="small-input"
                      @click.native="setRevealPosition(field.slug, field.focus.ratio, field.focus.x, field.focus.y)"

                  >
                    {{ field.answers[0].label }}
                  </b-checkbox>
                </qualify-sidebar-input-item>
                <qualify-sidebar-input-item :is-filled="fields[field.slug] !== ''" v-else-if="field.type === 'radio'" class="is-flex-wrap-wrap">
                  <b-radio
                      v-for="(option, index) in field.answers"
                      :key="`radio_${field.slug}_${index}`"
                      v-model="fields[field.slug]"
                      :name="field.slug"
                      :native-value="option.value"
                      class="image-input"
                      @click.native="setRevealPosition(field.slug, 0.20, 50, 50)"

                  >
                    <span  v-if="option.image">{{ option.label}}</span>
                    <img v-if="option.image"
                         class="radio-image"
                         :src="option.image"
                         :alt="option.label"/>
                    <template v-else>{{ option.label }}</template>
                  </b-radio>
                </qualify-sidebar-input-item>
                <qualify-sidebar-input-item :suffix="field.unit[unitType]" :is-filled="fields[field.slug] !== ''" v-else>
                  <b-input
                      v-model="fields[field.slug]"
                      size="is-large"
                      class="small-input"
                      @focus="setRevealPosition(field.slug, field.focus.ratio, field.focus.x, field.focus.y)"
                      @blur="setRevealPosition()"
                      rounded
                  />
                </qualify-sidebar-input-item>
              </qualify-sidebar-input-container>
            </template>

            <hr v-if="index < fieldGroups.length - 1" class="group-separator"/>
        </section>

        <!-- old non generic fields
        <h2 class="sidebar-title">
            {{ $t('take_measurement_of_building_and_shelves') }}
        </h2>

        &lt;!&ndash;<qualify-sidebar-input-container :label="$t('minimum_aisle_width')" :is-mandatory="true">&ndash;&gt;
        <qualify-sidebar-input-container :label="$t('minimum_aisle_width')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="minimumAisleWidth.length > 0">
                <b-input
                    v-model="minimumAisleWidth"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.04, 57, 64)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        &lt;!&ndash;<qualify-sidebar-input-container :label="$t('max_lifting_height')" :is-mandatory="true">&ndash;&gt;
        <qualify-sidebar-input-container :label="$t('max_lifting_height')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="maxLiftingHeight.length > 0">
                <b-input
                    v-model="maxLiftingHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.04, 57, 53)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('ramp')">
            <qualify-sidebar-input-item :suffix="$tc('x_of_length', 'mm')" :is-filled="rampLength.length > 0">
                <b-input
                    v-model="rampLength"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.10, 42, 82)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
            <qualify-sidebar-input-item :suffix="$tc('x_of_height', 'mm')" :is-filled="rampHeight.length > 0">
                <b-input
                    v-model="rampHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.04, 44, 77)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>

            <transition name="fade">
                <div class="ramp-slope-percentage-calc" :class="brandBackgroundColor" v-if="rampSlopePercentageCalc">
                    = {{ $tc('slope_of', rampSlopePercentageCalc)}}
                </div>
            </transition>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('passage_width')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="passageWidth.length > 0">
                <b-input
                    v-model="passageWidth"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.035, 45, 73)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('passage_height')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="passageHeight.length > 0">
                <b-input
                    v-model="passageHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.05, 45, 70)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

      &lt;!&ndash; retiré
        <qualify-sidebar-input-container :label="$t('passage_first_stringer')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="passageFirstStringer.length > 0">
                <b-input
                    v-model="passageFirstStringer"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.04, 46.5, 53.5)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>
        &ndash;&gt;

        <qualify-sidebar-input-container :label="$t('ceiling_height')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="ceilingHeight.length > 0">
                <b-input
                    v-model="ceilingHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.06, 67, 42)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('luminaire_height')">
            <qualify-sidebar-input-item :suffix="'mm'" :is-filled="luminaireHeight.length > 0">
                <b-input
                    v-model="luminaireHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.04, 59.5, 38)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>

        <qualify-sidebar-input-container :label="$t('residual_capacity_max_height')">
            <qualify-sidebar-input-item :suffix="'kg'" :is-filled="residualCapacityMaxHeight.length > 0">
                <b-input
                    v-model="residualCapacityMaxHeight"
                    size="is-large"
                    class="small-input"
                    autocomplete="new-password"
                    @focus="setRevealPosition(0.035, 52, 48)"
                    @blur="setRevealPosition()"
                    rounded
                />
            </qualify-sidebar-input-item>
        </qualify-sidebar-input-container>-->
    </div>
</template>

<script>
    import QualifySidebarInputContainer from "@/components/QualifySidebarInput/QualifySidebarInputContainer.vue"
    import QualifySidebarInputItem from "@/components/QualifySidebarInput/QualifySidebarInputItem.vue"
    import {mapState} from "vuex";

    export default {
        name: 'QualifyIndustryBuildingAndShelving',
        components:{
            QualifySidebarInputContainer,
            QualifySidebarInputItem
        },
        data() {
          return {
            currentField: '',
            rampDiagonal: null,
            rampError: "",
            rampPercentage: null
          }
        },
        computed: {
            ...mapState({
              environment: state => state.qualifyIndustry.environment,
              environments: state => state.qualifyIndustry.environments,
              currentStep: state => state.qualifyIndustry.currentStep,
              // fields: state => state.qualifyIndustry.fields,
              unitType: state => state.settings.unitType,
            }),
            fields: {
                get () { return this.$store.state.qualifyIndustry.fields[this.currentSurveyId] },
                set (value) {
                  this.$store.commit('qualifyIndustry/setFields', {survey: this.currentSurveyId, field: this.currentField, value})
                }
            },
            minimumAisleWidth: {
                get () { return this.$store.state.qualifyIndustry.minimumAisleWidth },
                set (value) { this.$store.commit('qualifyIndustry/setMinimumAisleWidth', value) }
            },
            maxLiftingHeight: {
                get () { return this.$store.state.qualifyIndustry.maxLiftingHeight },
                set (value) { this.$store.commit('qualifyIndustry/setMaxLiftingHeight', value) }
            },
            rampLength: {
                get () { return this.$store.state.qualifyIndustry.rampLength },
                set (value) { this.$store.commit('qualifyIndustry/setRampLength', value) }
            },
            rampHeight: {
                get () { return this.$store.state.qualifyIndustry.rampHeight },
                set (value) { this.$store.commit('qualifyIndustry/setRampHeight', value) }
            },
            passageWidth: {
                get () { return this.$store.state.qualifyIndustry.passageWidth },
                set (value) { this.$store.commit('qualifyIndustry/setPassageWidth', value) }
            },
            passageHeight: {
                get () { return this.$store.state.qualifyIndustry.passageHeight },
                set (value) { this.$store.commit('qualifyIndustry/setPassageHeight', value) }
            },
            passageFirstStringer: {
                get () { return this.$store.state.qualifyIndustry.passageFirstStringer },
                set (value) { this.$store.commit('qualifyIndustry/setPassageFirstStringer', value) }
            },
            ceilingHeight: {
                get () { return this.$store.state.qualifyIndustry.ceilingHeight },
                set (value) { this.$store.commit('qualifyIndustry/setCeilingHeight', value) }
            },
            luminaireHeight: {
                get () { return this.$store.state.qualifyIndustry.luminaireHeight },
                set (value) { this.$store.commit('qualifyIndustry/setLuminaireHeight', value) }
            },
            residualCapacityMaxHeight: {
                get () { return this.$store.state.qualifyIndustry.residualCapacityMaxHeight },
                set (value) { this.$store.commit('qualifyIndustry/setResidualCapacityMaxHeight', value) }
            },
            rampSlopePercentageCalc(){
                // console.log('calcul');
                // if(this.rampDiagonal && this.rampDiagonal !== (Math.round(Math.sqrt(Math.pow(this.fields.rampHeight, 2) + Math.pow(this.fields.rampLength, 2))))) {
                //     if (!this.fields.rampHeight) {
                //         this.rampError = "Renseignez la hauteur de la rampe pour ce calcul";
                //     } else {
                //         this.rampError = "";
                //         this.fields.rampLength = Math.round(Math.sqrt(Math.pow(this.rampDiagonal, 2) - Math.pow(this.fields.rampHeight, 2))).toString();
                //     }
                //     console.log('edit diagonal')
                //     return (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                // } else if (this.fields.rampLength && this.fields.rampHeight) {
                //     console.log('edit length');
                //     this.rampError = "";
                //     this.rampDiagonal = Math.round(Math.sqrt(Math.pow(this.fields.rampHeight, 2) + Math.pow(this.fields.rampLength, 2)));
                //     return (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                // } else return 0;
                // if(this.rampLength.length > 0 && this.rampHeight.length > 0)
                //     return (Math.round(((this.rampHeight/this.rampLength)*100) * 100) / 100);
            },
            fieldGroups() {
              if (this.environment) {
                let currentEnv = this.environments.find(env => env.slug === this.environment);
                // console.log("Environnement : ", currentEnv);
                if (currentEnv && currentEnv.steps) {
                  let currentStepData = currentEnv.steps.find(step => this.currentStep.includes(step.slug.replaceAll('_', '-')));
                  // console.log(currentStepData);
                  if (currentStepData && currentStepData.survey) return currentStepData.survey.groups;
                }
              }
              return [];
            },
            currentSurveyId() {
              if (this.environment) {
                let currentEnv = this.environments.find(env => env.slug === this.environment);
                if (currentEnv && currentEnv.steps) {
                  let currentStepData = currentEnv.steps.find(step => this.currentStep.includes(step.slug.replaceAll('_', '-')));
                  if (currentStepData && currentStepData.survey) return currentStepData.survey.id;
                }
              }
              return null;
            }
        },
        created(){
            if(!this.$route.query.backward)
                this.$store.commit('qualifyIndustry/resetBuildingAndShelving');

            this.presetFields();

            this.$store.commit('qualifyIndustry/setNextStepAllowed', false);
            this.checkNextStepAllowed();

            this.$watch(vm => [
                vm.fields
            ].join(), () => this.checkNextStepAllowed())
        },
        watch: {
          '$route' (to) {
            // let toStep = this.steps.find(x => x.slug === to.params.step);
            // if (toStep) this.$store.commit('qualifyIndustry/setCurrentStep', toStep.code);
            // else this.$store.commit('qualifyIndustry/setCurrentStep', to.params.step);
            this.presetFields();
          },
          rampDiagonal(to) {
            // console.log('edit', to);
          }
        },
        methods: {
            presetFields() {
              let defaultFields = {};

              this.fieldGroups.forEach(group => {
                group.questions.forEach(field => {
                  if (field.slug === "ramp") {
                    defaultFields['rampLength'] = '';
                    defaultFields['rampHeight'] = '';
                  } else defaultFields[field.slug] = '';
                })
              })

              let fields = [];
              fields[this.currentSurveyId] = defaultFields;
              // console.log("Preset fields : ", fields);

              // console.log(defaultFields);
              this.$store.commit('qualifyIndustry/setDefaultStepFields', fields);
            },
            calcPercent(type) {
                // console.log('calcul');
                if (this.fields.rampLength && this.fields.rampHeight && type !== 'rampDiagonal') {
                    // console.log('edit length');
                    this.rampError = "";
                    this.rampDiagonal = Math.round(Math.sqrt(Math.pow(this.fields.rampHeight, 2) + Math.pow(this.fields.rampLength, 2)));
                    this.rampPercentage = (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                } else if(this.rampDiagonal) {
                    // console.log('edit diagonal');
                    if (!this.fields.rampHeight) {
                        this.rampError = "Renseignez la hauteur de la rampe pour ce calcul";
                    } else {
                        this.rampError = "";
                        this.fields.rampLength = Math.round(Math.sqrt(Math.pow(this.rampDiagonal, 2) - Math.pow(this.fields.rampHeight, 2))).toString();
                    }
                    this.rampPercentage = (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                } else this.rampPercentage = 0;

                this.fields.ramp = this.rampPercentage

                /*if(this.rampDiagonal && this.rampDiagonal !== (Math.round(Math.sqrt(Math.pow(this.fields.rampHeight, 2) + Math.pow(this.fields.rampLength, 2))))) {
                    if (!this.fields.rampHeight) {
                        this.rampError = "Renseignez la hauteur de la rampe pour ce calcul";
                    } else {
                        this.rampError = "";
                        this.fields.rampLength = Math.round(Math.sqrt(Math.pow(this.rampDiagonal, 2) - Math.pow(this.fields.rampHeight, 2))).toString();
                    }
                    console.log('edit diagonal')
                    this.rampPercentage = (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                } else if (this.fields.rampLength && this.fields.rampHeight) {
                    console.log('edit length');
                    this.rampError = "";
                    this.rampDiagonal = Math.round(Math.sqrt(Math.pow(this.fields.rampHeight, 2) + Math.pow(this.fields.rampLength, 2)));
                    this.rampPercentage = (Math.round(((this.fields.rampHeight/this.fields.rampLength)*100) * 100) / 100);
                } else this.rampPercentage = 0;*/
            },
            checkNextStepAllowed(){
                this.$store.commit('qualifyIndustry/setNextStepAllowed', this.fields.ground_type !== "");
              // this.$store.commit('qualifyIndustry/setNextStepAllowed', true);
            },
            setRevealPosition(fieldName, revealSizeRatio = null, revealLeftPositionPercentage = null, revealTopPositionPercentage = null){
              if (revealSizeRatio && revealLeftPositionPercentage && revealTopPositionPercentage) {
                  this.currentField = fieldName;
                  this.$bus.$emit('changeQualifyRevealPosition', {
                      revealSizeRatio: revealSizeRatio,
                      revealLeftPositionPercentage: revealLeftPositionPercentage,
                      revealTopPositionPercentage: revealTopPositionPercentage,
                  });
              } else {
                  this.currentField = null;
                  let validFields = ['rampLength', 'rampHeight', 'rampDiagonal'];
                  if (validFields.includes(fieldName)) {
                      this.calcPercent(fieldName);
                  }
              }
              setTimeout(() => {
                // console.log(fieldName, this.fields, this.fields[fieldName]);

                this.checkNextStepAllowed()
                this.$forceUpdate();
              })
            },
        }
    }
</script>

<style lang="scss">
.view-qualify-step-building-and-shelving {
    .ramp-slope-percentage-calc {
        display: inline-block;
        padding: 13px 20px;
        font-size: 18px;
        color: $white;
        font-weight: 700;
    }
}
.b-radio.radio {
  align-items: unset;
}

hr.group-separator {
  background-color: $brand_red;
}

.image-input {
  flex-basis: 100%;
  margin-bottom: 12px;

  .radio-image {
    //max-width: 130px;
    //width: 50%;
    margin: 0 5px;
    height: auto;
  }

  /deep/ .control-label {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .control-label {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    text-transform: capitalize;
  }
}
</style>
